'use client'

import type { ReactNode } from 'react'
import { useAppPromotionCookie } from '@/app/lib/hooks/useAppPromotionCookie'

interface FooterVisibilityGateProps {
  children: ReactNode
}

/**
 * Oculta el footer completo cuando el sitio se abre dentro de la vista de la
 * app (cookie `eciAppVersion=eci-app-focus`) — ni la navegación del footer ni
 * su promoción de descarga de la propia app tienen sentido ahí. Visible por
 * defecto (servidor y primer render de cliente coinciden, sin *hydration
 * mismatch* — ver `useAppPromotionCookie`); se oculta tras montar si detecta
 * el modo app.
 */
export function FooterVisibilityGate({ children }: FooterVisibilityGateProps) {
  const isAppContext = useAppPromotionCookie()

  if (isAppContext) return null

  return <>{children}</>
}
